import PropTypes from 'prop-types'
import React from 'react'
import { withNamespaces } from 'react-i18next'

class CheckAllButton extends React.Component {
  render() {
    return (
      <button className='filter__all' type='button' onClick={this.props.onClick}>
        {this.props.t('checkAll')}
      </button>
    )
  }
}

export default withNamespaces('searchForm')(CheckAllButton)

CheckAllButton.propTypes = {
  onClick: PropTypes.func
};
